import { render, staticRenderFns } from "./BuyNowButton.vue?vue&type=template&id=4f544ffa&scoped=true&"
import script from "./BuyNowButton.vue?vue&type=script&lang=js&"
export * from "./BuyNowButton.vue?vue&type=script&lang=js&"
import style0 from "./BuyNowButton.vue?vue&type=style&index=0&id=4f544ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f544ffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4f544ffa', component.options)
    } else {
      api.reload('4f544ffa', component.options)
    }
    module.hot.accept("./BuyNowButton.vue?vue&type=template&id=4f544ffa&scoped=true&", function () {
      api.rerender('4f544ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/common_components/BuyNowButton.vue"
export default component.exports